/** Small formatters for the People tables: dates, counts, and the district and standing words. */
import type { StandingKey } from "../../data/types";

export { fmtDate } from "../../data/format";

/** "District 3" and "3" both read "3": the column header already says District. */
export function shortDistrict(value: string | number | null | undefined): string {
  if (value == null || value === "") return "—";
  return String(value).replace(/^district\s+/i, "");
}

/** Map any source's standing word onto the four stamps; null when the source has none (or the person is deceased). */
export function standingOf(value: string | null | undefined): StandingKey | null {
  switch ((value ?? "").toLowerCase().replace(/[\s-]/g, "_")) {
    case "active":
      return "active";
    case "lapsed":
      return "lapsed";
    case "suspended":
      return "suspended";
    case "non_member":
    case "nonmember":
      return "non_member";
    default:
      return null;
  }
}

export function plural(n: number, one: string, many: string): string {
  return `${n.toLocaleString("en-US")} ${n === 1 ? one : many}`;
}

/** "snake_case" or "kebab-case" to "Sentence case". */
export function sentence(value: string | null | undefined): string {
  if (!value) return "—";
  const text = value.replace(/[_-]+/g, " ").trim();
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** Days from today as a person says them, one way down a column: "Today", "1 day", "2 days", and "3 days ago" once past. */
export function daysWord(days: string | undefined): string {
  const n = Number(days);
  if (days === undefined || days === "—" || Number.isNaN(n)) return "—";
  if (n === 0) return "Today";
  return n < 0 ? `${plural(-n, "day", "days")} ago` : plural(n, "day", "days");
}
